import { setTheme } from "theme/default/setTheme";

export const color_47a0ef = setTheme(({ theme }) => theme.colors.color_47a0ef);
